import React from 'react';
import {Route, Redirect } from 'react-router-dom';
import {userIsInGroup, READ_ONLY_GROUP,DRIVER_GROUP} from '../../utils/groups';
import ForbiddenPage from '../../views/ForbiddenPage';
import DriverForbbidenPage from '../../views/DriverForbbidenPage';

const ReadOnlyRoute = ({children,isLoggedIn,user,...rest}) =>(
        <Route
            {...rest}
            render={(routerProps) =>{
                if(user){
                    if(isLoggedIn){
                        if (userIsInGroup(user,READ_ONLY_GROUP)) {
                            const childrenWithMatch = React.Children.map(children, child => 
                                React.cloneElement(child,routerProps));
                            return (childrenWithMatch)
                        } else if (userIsInGroup(user,DRIVER_GROUP)) {
                            return(<DriverForbbidenPage/>);
                        } else {
                            return(<ForbiddenPage/>)
                        }
                    }
                    else {
                        return (<Redirect to='/login'/>);
                    }
                    
                } else {
                    return (<Redirect to='/login'/>);
                }
            }}
        />
    );


export default ReadOnlyRoute;